export default {"src":"/_next/static/image/public/images/ic_download_blue.25e871dca9ecd52d96c47343c1ef90f4.svg","height":19,"width":19};